export default __webpack_public_path__ + "media/elmnt-1.26a79675.svg";